import axios from "axios";
import {Auth} from "@aws-amplify/auth";

const api_baseURL = process.env.VUE_APP_API_ENDPOINT;
const client_subdomain = window.location.hostname.split('.')[0];

let wss = window.sessionStorage;
let wls = window.localStorage;
let wlsk = 'userInfo';
const lcl_userInfo = {
   //Local Storage - Needed for multi tab browsing/session
   getUserInfo: () => {return JSON.parse(wls.getItem(wlsk));},
   setUserInfo: (ui) => {wls.setItem(wlsk, JSON.stringify(ui));},
   removeUserInfo: () => {wls.removeItem(wlsk);}
};


//Individual Imports
export {
   api_baseURL,
   client_subdomain,
   lcl_userInfo,
   fn_getAppInfoAuthConfig,
   fn_get_IdToken,
   fn_appUserSession,
};

function fn_getAppInfoAuthConfig() {
   return axios({
      method: "GET",
      url: api_baseURL,
      params: {authConfig: true},
      headers: {subdomain: client_subdomain},
   }).then(resp => resp.data).catch(err => ({err: err.message}));
}

function fn_appUserSession(eventId, isLogOut) {
   return fn_get_IdToken().then(idTkn => {
      return axios({
         method: "POST",
         url: api_baseURL + 'userSession',
         contentTYpe: 'application/json; charset=utf-8',
         data: {eventId, isLogOut},
         headers: {
            subdomain: client_subdomain,
            "Authorization": "Bearer " + idTkn,
         },
      }).then(resp => {return resp.data;}).catch(err => {return err;});
   });
}


async function fn_get_IdToken() {
   let ui = lcl_userInfo.getUserInfo();
   if (!ui || !ui.keyPrefix || !ui.username) {
      lcl_userInfo.removeUserInfo();
      wss.setItem('sessionExp', true);
      window.location.href = '/logout';
      return;
   }

   // let min = ((ui.exp_time - Date.now()) / 1000 / 60).toFixed(2) + ' min';
   // console.log('Time to Token Expiration: ', min);

   let isExpired = Date.now() > ui.exp_time;
   if (!isExpired) {
      let key = `${ui.keyPrefix}.${ui.username}.idToken`;
      //Need to change to httpOnly Cookiie
      var re = new RegExp(key + "=([^;]+)");
      var idTkn = re.exec(document.cookie);
      idTkn = (idTkn != null) ? decodeURI(idTkn[1]) : null;
      return new Promise(function(res, rej) {
         res(idTkn);
      });
   }
   else {
      // console.log('TOKEN EXPIRED');
      let cognitoUser = await Auth.currentAuthenticatedUser();
      let currSess = await Auth.currentSession();
      return new Promise((res, rej) => {
         cognitoUser.refreshSession(currSess.refreshToken, (err, sess) => {
            // console.log('Refreshing Token...');
            if (!sess) {
               //Refresh Token Expired
               // console.log('Refresh Token Expired, logging out');
               wss.setItem('sessionExp', true);
               window.location.href = '/logout';
               return;
            }

            ui.exp_time = sess.idToken.payload.exp * 1000;
            // ui.exp_time_str = util.fn_fmtDtm(ui.exp_time);
            ui.rfsh_time = Date.now();
            // ui.rfsh_time_str = util.fn_fmtDtm(ui.rfsh_time);
            lcl_userInfo.setUserInfo(ui);
            let idTkn = sess.idToken.jwtToken;
            // console.log('Token Refreshed to', ui.exp_time_str);
            res(idTkn);
         });
      });
   }
}